import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";

import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Vehicles from "@/pages/Vehicles";
import Templates from "@/pages/Templates";
import TemplateBuilder from "@/pages/TemplateBuilder";
import Inbox from "@/pages/Inbox";
import ChecklistFiller from "@/pages/ChecklistFiller";
import Approvals from "@/pages/Approvals";
import Workshops from "@/pages/Workshops";
import Parts from "@/pages/Parts";
import Quotes from "@/pages/Quotes";
import Integration from "@/pages/Integration";
import Reports from "@/pages/Reports";
import Collaborators from "@/pages/Collaborators";
import FuelStock from "@/pages/FuelStock";

import "@/App.css";

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            richColors
            closeButton
          />

          <Routes>
            {/* Login */}
            <Route
              path="/login"
              element={<Login />}
            />

            {/* Área autenticada */}
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >

              {/* =========================
                  TODOS OS USUÁRIOS
              ========================= */}

              <Route
                path="/"
                element={<Dashboard />}
              />

              <Route
                path="/inbox"
                element={<Inbox />}
              />

              <Route
                path="/inbox/:taskId"
                element={<ChecklistFiller />}
              />

              {/* =========================
                  FROTA

                  Admin
                  Gestor
                  Motorista
                  Mecânico
                  Abastecedor
              ========================= */}

              <Route
                path="/vehicles"
                element={
                  <ProtectedRoute
                    roles={["admin", "gestor"]}
                    subRoles={[
                      "motorista",
                      "mecanico",
                      "abastecedor"
                    ]}
                  >
                    <Vehicles />
                  </ProtectedRoute>
                }
              />

              {/* =========================
                  MODELOS DE CHECKLIST

                  Admin
                  Gestor
              ========================= */}

              <Route
                path="/templates"
                element={
                  <ProtectedRoute
                    roles={["admin", "gestor"]}
                  >
                    <Templates />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/templates/new"
                element={
                  <ProtectedRoute
                    roles={["admin", "gestor"]}
                  >
                    <TemplateBuilder />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/templates/:id"
                element={
                  <ProtectedRoute
                    roles={["admin", "gestor"]}
                  >
                    <TemplateBuilder />
                  </ProtectedRoute>
                }
              />

              {/* =========================
                  APROVAÇÕES

                  Admin
                  Gestor
              ========================= */}

              <Route
                path="/approvals"
                element={
                  <ProtectedRoute
                    roles={["admin", "gestor"]}
                  >
                    <Approvals />
                  </ProtectedRoute>
                }
              />

              {/* =========================
                  OFICINAS

                  Admin
                  Gestor
                  Mecânico
              ========================= */}

              <Route
                path="/workshops"
                element={
                  <ProtectedRoute
                    roles={["admin", "gestor"]}
                    subRoles={["mecanico"]}
                  >
                    <Workshops />
                  </ProtectedRoute>
                }
              />

              {/* =========================
                  PEÇAS

                  Admin
                  Gestor
                  Mecânico
              ========================= */}

              <Route
                path="/parts"
                element={
                  <ProtectedRoute
                    roles={["admin", "gestor"]}
                    subRoles={["mecanico"]}
                  >
                    <Parts />
                  </ProtectedRoute>
                }
              />

              {/* =========================
                  ORÇAMENTOS

                  Admin
                  Gestor
                  Mecânico
              ========================= */}

              <Route
                path="/quotes"
                element={
                  <ProtectedRoute
                    roles={["admin", "gestor"]}
                    subRoles={["mecanico"]}
                  >
                    <Quotes />
                  </ProtectedRoute>
                }
              />

              {/* =========================
                  INTEGRAÇÕES

                  Admin
                  Gestor
              ========================= */}

              <Route
                path="/integration"
                element={
                  <ProtectedRoute
                    roles={["admin"]}
                  >
                    <Integration />
                  </ProtectedRoute>
                }
              />

              {/* =========================
                  RELATÓRIOS

                  Admin
                  Gestor
              ========================= */}

              <Route
                path="/reports"
                element={
                  <ProtectedRoute
                    roles={["admin", "gestor"]}
                  >
                    <Reports />
                  </ProtectedRoute>
                }
              />

              {/* =========================
                  COLABORADORES

                  Admin
                  Gestor
              ========================= */}

              <Route
                path="/collaborators"
                element={
                  <ProtectedRoute
                    roles={["admin", "gestor"]}
                  >
                    <Collaborators />
                  </ProtectedRoute>
                }
              />

              {/* =========================
                  COMBUSTÍVEL

                  Admin
                  Gestor
                  Abastecedor
              ========================= */}

              <Route
                path="/fuel"
                element={
                  <ProtectedRoute
                    roles={["admin", "gestor"]}
                    subRoles={["abastecedor"]}
                  >
                    <FuelStock />
                  </ProtectedRoute>
                }
              />

            </Route>

            {/* Qualquer rota inválida volta para o Dashboard */}
            <Route
              path="*"
              element={<Navigate to="/" replace />}
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}